<div class="form-group {{class}}">
  <label *ngIf="labelCaption" class="{{labelClass}}"
    [ngClass]="{'col-form-label': !labelStacked, 'col-form-label-sm': sm}">
    <span *ngIf="labelCaption">
      {{labelCaption}}
      <span *ngIf="!editable">:</span>
    </span>
    <span *ngIf="editable && required" class="asterix"> *</span>
  </label>
  <div class="input-container {{inputClass}}" [ngClass]="{'data-value': !editable}">
    <label *ngIf="!editable" class="col-form-label" [ngClass]="{'col-form-label-sm': sm}">{{getCheckedTexts()}}</label>
    <div [hidden]="!editable" *ngFor="let item of items" class="form-check">
      <input type="checkbox" [id]="id+'_'+item.id" [checked]="item.checked" [disabled]="item.disabled || disabled"
        (change)="toggle(item)" class="form-check-input"
        [ngClass]="{'is-invalid': editable && ngControl.invalid && (ngControl.touched || submitted)}">
      <label class="form-check-label" [for]="id+'_'+item.id">&nbsp;{{item.text}}</label>
    </div>
    <ng-content></ng-content>
  </div>
</div>